var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "swb-back-row" }, [
      _c("div", { staticClass: "order-detail-panel mt20" }, [
        _vm.checkActionPerm("update_discount")
          ? _c("div", { staticClass: "btn-row" }, [
              _c("div", { staticClass: "fr" }, [
                _vm.showUpdateDiscount
                  ? _c(
                      "div",
                      { staticClass: "inline-block" },
                      [
                        _c("span", { staticClass: "inline-block" }, [
                          _vm._v("税率(%)：")
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "ml10 mr10",
                          staticStyle: { width: "auto" },
                          attrs: { type: "text" },
                          on: { blur: _vm.changeTaxRate },
                          model: {
                            value: _vm.taxRate,
                            callback: function($$v) {
                              _vm.taxRate = $$v
                            },
                            expression: "taxRate"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.showUpdateDiscount
                  ? _c(
                      "div",
                      {
                        staticClass: "swb-btn swb-btn-small",
                        on: {
                          click: function($event) {
                            _vm.showUpdateDiscount = true
                          }
                        }
                      },
                      [_vm._v("改价")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showUpdateDiscount
                  ? _c(
                      "div",
                      {
                        staticClass: "swb-btn swb-btn-small",
                        on: { click: _vm.updateDiscount }
                      },
                      [_vm._v("保存改价")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showUpdateDiscount
                  ? _c(
                      "div",
                      {
                        staticClass: "swb-btn swb-btn-small",
                        on: { click: _vm.cancelPrice }
                      },
                      [_vm._v("取消改价")]
                    )
                  : _vm._e()
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "trade-status" }, [
          _c("table", { staticClass: "trade-status-table" }, [
            _c("tbody", [
              _c("tr", [
                _c("td", { staticClass: "trade-imfor table-td" }, [
                  _c("div", { staticClass: "info-block" }, [
                    _c("div", { staticClass: "trade-imfor-title pl20" }, [
                      _vm._v("订单详情")
                    ]),
                    _vm._v(" "),
                    _c("ul", { staticClass: "pb15" }, [
                      _c("li", { staticClass: "table-list" }, [
                        _c("div", { staticClass: "trade-imfor-dt" }, [
                          _vm._v("买家留言")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "trade-imfor-dd" }, [
                          _vm.goodsOrder.postscript != null
                            ? _c("div", [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.goodsOrder.postscript))
                                ])
                              ])
                            : _c("div", [_c("span", [_vm._v("-")])])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "table-list" }, [
                        _c("div", { staticClass: "trade-imfor-dt" }, [
                          _vm._v("订单编号")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "trade-imfor-dd" }, [
                          _vm._v(_vm._s(_vm.goodsOrder.no))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "table-list" }, [
                        _c("div", { staticClass: "trade-imfor-dt" }, [
                          _vm._v("商家")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "trade-imfor-dd" }, [
                          _vm._v(_vm._s(_vm.goodsOrder.sellerName))
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "trade-detail table-td" }, [
                  _c("div", { staticClass: "trade-detail-imfor pl30" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm.goodsOrder.shipState == 0
                      ? _c("div", { staticClass: "imfor-title" }, [
                          _c("h3", [_vm._v("交付状态: 商家未发货，联系商家")])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.goodsOrder.shipState != 0 &&
                    _vm.goodsOrder.recvState == 0
                      ? _c("div", { staticClass: "imfor-title" }, [
                          _c("h3", [
                            _vm._v("交付状态: 商家已发货，等待确认收货")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.goodsOrder.shipState != 0 &&
                    _vm.goodsOrder.recvState == 1
                      ? _c("div", { staticClass: "imfor-title" }, [
                          _c("h3", [_vm._v("交付状态: 已部分收货")])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.goodsOrder.shipState != 0 &&
                    _vm.goodsOrder.recvState == 2
                      ? _c("div", { staticClass: "imfor-title" }, [
                          _c("h3", [_vm._v("交付状态: 已收货")])
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "trade-detail-prompt" }, [
                    _c("li", [
                      _c("span", [_vm._v("▪")]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("订单状态:" + _vm._s(_vm.goodsOrder.state))
                      ]),
                      _vm._v(" "),
                      _vm.goodsOrder.cancelled
                        ? _c("div", [
                            _c("span", [_vm._v("▪")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "取消原因：" +
                                  _vm._s(_vm.goodsOrder.cancelCause)
                              )
                            ])
                          ])
                        : _vm._e()
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "store-list mt10 mb10" }, [
        _c(
          "table",
          { staticClass: "cart-table" },
          [
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _vm._l(_vm.goodsOrder.itemList, function(goodsOrderItem, index) {
              return _vm.goodsOrder.itemList != null &&
                _vm.goodsOrder.itemList.length > 0
                ? _c("tbody", { staticClass: "cart-tbody" }, [
                    _vm._m(3, true),
                    _vm._v(" "),
                    _c("tr", { staticClass: "row" }, [
                      _c("td", [
                        _c("div", { staticClass: "goods-box clearfix" }, [
                          _c("div", { staticClass: "goods-img" }, [
                            _c("img", {
                              staticClass: "wh100",
                              attrs: { src: goodsOrderItem.skuDefaultImageUrl }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "goods-detail" }, [
                            _c("p", { staticClass: "name" }, [
                              _vm._v(_vm._s(goodsOrderItem.title))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "other" }, [
                              _c("p", [
                                _vm._v(
                                  "分类：" + _vm._s(goodsOrderItem.catName)
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "品牌：" + _vm._s(goodsOrderItem.brandName)
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v("型号：" + _vm._s(goodsOrderItem.model))
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "规格：" + _vm._s(goodsOrderItem.fixedSpec)
                                )
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", [
                          _vm._v(
                            _vm._s(goodsOrderItem.asmblAccFlag ? "是" : "否")
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", [_vm._v(_vm._s(goodsOrderItem.taxRate))])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", [_vm._v(_vm._s(goodsOrderItem.wrntPeriod))])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", [_vm._v(_vm._s(goodsOrderItem.quantity))])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", [_vm._v(_vm._s(goodsOrderItem.unit))])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", [_vm._v(_vm._s(goodsOrderItem.desc))])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "row other" }, [
                      _c("td", { attrs: { colspan: "7" } }, [
                        _c("div", { staticClass: "overflow-content" }, [
                          _c("p", [
                            _c("span", [_vm._v("含税价(元)：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "¥ " +
                                  _vm._s(
                                    parseFloat(
                                      goodsOrderItem.price || 0
                                    ).toFixed(2)
                                  )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("span", [_vm._v("未税价(元)：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "¥ " +
                                  _vm._s(
                                    parseFloat(
                                      goodsOrderItem.ntxPrice || 0
                                    ).toFixed(2)
                                  )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("span", [_vm._v("优惠金额(元)：")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              [
                                !_vm.showUpdateDiscount
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "display-block",
                                        staticStyle: { width: "inherit" }
                                      },
                                      [
                                        _vm._v(
                                          "¥ " +
                                            _vm._s(
                                              parseFloat(
                                                goodsOrderItem.discount || 0
                                              ).toFixed(2)
                                            )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showUpdateDiscount
                                  ? _c("el-input", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        type: "number",
                                        controls: false,
                                        min: 0,
                                        max:
                                          goodsOrderItem.price *
                                          goodsOrderItem.quantity
                                      },
                                      on: {
                                        blur: function($event) {
                                          _vm.changeExtraDistCount(
                                            goodsOrderItem.discount
                                          )
                                        }
                                      },
                                      model: {
                                        value: goodsOrderItem.discount,
                                        callback: function($$v) {
                                          _vm.$set(
                                            goodsOrderItem,
                                            "discount",
                                            $$v
                                          )
                                        },
                                        expression: "goodsOrderItem.discount"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("span", [_vm._v("协议小计(元)：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "¥ " +
                                  _vm._s(
                                    parseFloat(
                                      goodsOrderItem.amount || 0
                                    ).toFixed(2)
                                  )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("span", [_vm._v("结算小计(元)：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "¥ " +
                                  _vm._s(
                                    parseFloat(
                                      goodsOrderItem.amount -
                                        goodsOrderItem.discount || 0
                                    ).toFixed(2)
                                  )
                              )
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                : _vm._e()
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "order-amount" }, [
        _c("div", { staticClass: "total-amount-panel" }, [
          _c("table", {}, [
            _c("tbody", [
              _c("tr", [
                _c("td", { staticClass: "total-count" }, [
                  _c("div", { staticClass: "total-count-wrapper" }, [
                    _c("div", { staticClass: "total-count-line" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("商品总价(元)：")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _c("span", [
                          _vm._v(
                            "¥ " +
                              _vm._s(
                                parseFloat(
                                  _vm.goodsOrder.totalAmount || 0
                                ).toFixed(2)
                              )
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "total-count-line" }, [
                      _c("span", { staticClass: "label font-bold" }, [
                        _vm._v("应付款(元)：")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _c(
                          "span",
                          { staticClass: "font14 font-black font-bold" },
                          [
                            _vm._v(
                              "¥ " +
                                _vm._s(
                                  _vm.goodsOrder.amount == null
                                    ? 0
                                    : _vm.goodsOrder.amount.toFixed(2)
                                )
                            )
                          ]
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "imfor-icon" }, [
      _c("i", {
        staticClass: "icon iconfont icon-info font-cyan",
        staticStyle: { "font-size": "32px" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { staticStyle: { width: "380px" } }),
      _vm._v(" "),
      _c("col", { staticStyle: { width: "140px" } }),
      _vm._v(" "),
      _c("col", { staticStyle: { width: "80px" } }),
      _vm._v(" "),
      _c("col", { staticStyle: { width: "140px" } }),
      _vm._v(" "),
      _c("col", { staticStyle: { width: "140px" } }),
      _vm._v(" "),
      _c("col", { staticStyle: { width: "140px" } }),
      _vm._v(" "),
      _c("col", { staticStyle: { width: "280px" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "cart-thead cart" }, [
      _c("tr", { staticClass: "row" }, [
        _c("th", [_vm._v("商品信息")]),
        _vm._v(" "),
        _c("th", [_vm._v("组装件")]),
        _vm._v(" "),
        _c("th", [_vm._v("税率(%)")]),
        _vm._v(" "),
        _c("th", [_vm._v("质保期(月)")]),
        _vm._v(" "),
        _c("th", [_vm._v("数量")]),
        _vm._v(" "),
        _c("th", [_vm._v("单位")]),
        _vm._v(" "),
        _c("th", [_vm._v("说明")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "tr",
      {
        staticClass: "row",
        staticStyle: { border: "none", "border-bottom": "1px solid #eee" }
      },
      [_c("td", { attrs: { colspan: "9" } })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01bcf5f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01bcf5f6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/GoodsOrderInfo.vue
// module id = 1813
// module chunks = 1